import {NotificationService} from './NotificationService';
import {CancellableNotificationService} from './CancellableNotificationService';

const notificationService = new NotificationService();
const cancellableNotificationService = new CancellableNotificationService(notificationService);

export function hideAllNotifications() {
    notificationService.clear();
}

export function pushCancellableNotification(message, options) {
    cancellableNotificationService.push(message, options);
}

export function pushNotification(message, options) {
    notificationService.push(message, options);
}
